function init() {
	// body...
	var $header = $('.header');
	var $notifWrap = $('.notif');
	var $NotifBtn = $('#notif');
	var $menuBtn = $('#navBtn');
	var $header_menu = $('.header__menu');
	var $header_menu_close = $('.header__menu-close');
	var $userMenu = $('.user-menu');

	$NotifBtn.hover(function() {
		if (windowWidth > SCREEN.MD) {
			$notifWrap.addClass('notif--show');
		}
	}, function() {
		return false;
	});

	$NotifBtn.on('click', function() {
		if (windowWidth <= SCREEN.MD) {
			$notifWrap.addClass('notif--show');
			$body.addClass('hide-overflow--nopad');
		}
	});

	$document.on('click.show-modal', function(event) {
		if ($notifWrap.hasClass('notif--show')) {
			if (!$(event.target).closest('.notif__wrap,#notif').length) {
				$notifWrap.removeClass('notif--show');
				$body.removeClass('hide-overflow--nopad');
			}
		}
	});


	$('.notif__wrap').on('mouseleave', function() {
		if (windowWidth > SCREEN.MD) {
			$notifWrap.removeClass('notif--show');
		}
	});

	$menuBtn.on('click',function () {
		$header_menu.toggleClass('show');
		$body.toggleClass('hide-overflow--nopad');
	});

	$header_menu_close.on('click',function () {
		$header_menu.removeClass('show');
		$body.removeClass('hide-overflow--nopad');
	});

	$('.header__menu-overlayer').on('click',function () {
		$header_menu.removeClass('show');
		$body.removeClass('hide-overflow--nopad');
	});

	$document.on('click.show-menu', function(event) {
		if ($header_menu.hasClass('show')) {
			if (!$(event.target).closest('.header__menu ul,#navBtn').length) {
				$header_menu.removeClass('show');
				$body.removeClass('hide-overflow--nopad');
			}
		}
	});

	$userMenu.on('click', function() {
		$userMenu.toggleClass('user-menu--open');
	});
}

$(function() {
	init();
});